import React, { useEffect, useState } from "react";
import "./PincodeModal.css";
import { Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Orange_Round_Arrow_Btn from "../../Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";

function PincodeModal({ setPincodeData, pincodeData, baseLink, ...props }) {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const onSubmit = async (data) => {
 
    setPincodeData(data?.pincode);
    props?.onHide();
  };
  return (
    <section className="PincodeModal modal-holder">
      <Modal
        {...props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="PincodeModal modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>Pincode</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="main_modal_div">
            <div className="form_holder">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="form-group">
                  <Form.Control
                    type="text"
                    name="pincode"
                    placeholder="Pincode"
                    {...register("pincode", {
                      required: "Pincode is required",
                    })}
                    className={classNames("", {
                      "is-valid": getValues("pincode"),
                    })}
                  />
                  {errors?.pincode && (
                    <span className="invalid-feedback d-block">
                      {errors.pincode.message}
                    </span>
                  )}
                </Form.Group>

                <div
                  className="apply_btn"
                  // onClick={() => {
                  //   props?.onHide();
                  // }}
                >
                  <Orange_Round_Arrow_Btn btn_name="Apply" type={"submit"} />
                </div>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default PincodeModal;
